// extracted by mini-css-extract-plugin
module.exports = {"button":"CustomModal_button__3Np_2","modal":"CustomModal_modal__o5xCD","close":"CustomModal_close__i3Rs9"};